import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	autocompleteSuggestion: {
		id: 'search_dialog_autocomplete_suggestion',
		defaultMessage: 'Suggestion',
		description: 'Label for autocomplete suggestions',
	},
});

